import { gate } from 'hub-http/gates';
import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
export const SALES_DOCUMENTS_BAD_ACTORS_GATE = gate('DealCollaboration:SalesDocumentsBadActors');
export const useIsUngatedToDocumentsBadActors = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.gates.includes(SALES_DOCUMENTS_BAD_ACTORS_GATE));
};
export const useHasDocumentsPaidAccessScope = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.user.scopes.includes('documents-paid-access'));
};